import _ from "lodash";
import Grid from "@mui/material/Grid";
import React, { useState, useEffect } from "react";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import { unicodeToString } from "../../../../Js/Common";

const pathToParentMenu = ["root"];

const WwListBg = (props) => {
  const [classnames, setClassnames] = useState("");

  useEffect(() => {
    // if (props.data && props.data.class) {
    //   setClassnames(props.data.class);
    // }
  }, [props.data]);

  return (
    <>
      {props.data && props.data.source && (
        <Grid container>
          <Grid item xs={12}>
            <Box
              sx={{
                pl: 0,
                my: 0.5,
                mt: 0.5,
                mr: 1,
                background: 'linear-gradient(to right, #eaeeff 0%,#eaeeff 72%,#ffffff 100%)',
                borderRadius: 3
              }}
            >
              <Typography variant="body1" sx={{ color: "primary.main", pl: 2, fontWeight: 500, py: 1}}>
                <div
                  className={classnames}
                  id={props.data.myId.self}
                  dangerouslySetInnerHTML={{
                    __html: unicodeToString(props.data.source),
                  }}
                  style={{display: props.initHide && props.initHide.indexOf(props.data.myId.self) > -1 ? 'none' : 'inline-block'}}
                ></div>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default WwListBg;
